import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { StoreSpecialWorkingHoursResponse, } from '../../../../interfaces/response/StoreResponses';
import { StoreSpecialWorkingTime } from '../../../models/store/StoreSpecialWorkingTime';
import { StoreWorkingTimeAdapter } from './StoreWorkingTimeAdapter';

/**
 * An adapter converts special store working time HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreSpecialWorkingTimeAdapter implements Adapter<StoreSpecialWorkingTime[]> {

  /**
   * Converts store special working time HTTP response to a list of {@link StoreSpecialWorkingTime}.
   * @param item store special working time HTTP response.
   */
  adapt(item: StoreSpecialWorkingHoursResponse[]): StoreSpecialWorkingTime[] {
    if (!item) {
      return [];
    }

    const workingTimeAdapter = new StoreWorkingTimeAdapter();
    const result: StoreSpecialWorkingTime[] = [];
    item.forEach($item => result.push(new StoreSpecialWorkingTime($item.date, workingTimeAdapter.adapt($item.workingHours))));
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
